import React from 'react';
import {connect} from "react-redux";
// import Select from 'react-select';
import Presenter from '../../../../master/tenant_setting/presenter.js';
import RequestProperties from '../../../../master/tenant_setting/helper/request.props.js';
import PermissionProperties from '../../../../config/permission.js'
import UserHelper from '../../../../helper/user.js'

import Websocket from 'react-websocket';
import ServerProperties from 'config/server.js';

import PopoverHelper from '../../../../utils/PopoverHelper';
import SelectQuery from '../../../../component/SelectQuery.js';
import Request from "config/Request.js"

// Upload
import axios from "axios"
import server from "../../../../config/server.js"
import urls from "../../../../config/url.js"
import getLogoBranding from "utils/getLogoBranding.js"
import {UpdateTenantCoverage} from "store/tenant/action.js"
// TOAST
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';

import lang from 'config/language' 

//UPdate uses session
import {
  UpdateTenantLogoLoginSession,
  UpdateTenantLogoDashboardSession,
  UpdateTenantLogoReportSession,
} from "store/tenant/action.js"
import windowStop from '../../../../utils/windowStop.js';

const
  HEIGHT_LOGIN = 300,
  WIDTH_LOGIN  = 300,

  HEIGHT_DASHBOARD = 40,
  WIDTH_DASHBOARD  = 200,

  HEIGHT_REPORT = 40,
  WIDTH_REPORT  = 200

class TenantSetting extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        SelectedSetting   : '',
        GlobalMaxDay      : 0,
        UrgencyDay        : 0,
        StorageType       : null,
        InactiveStatus    : null,
        MaintenanceType   : null,
        StorageStatus     : null,
        MaintenanceStatus : null,
        BusyStatus        : null,
        BrokenStatus      : null,
        LostStatus        : null,
        AdminRole         : null,
        StorageRole       : null,
        DefaultCurrency   : null,
        SingleCurrency    : 'False',
        CoverageCity      : false,
        toggled           : false,
        CustomBranding    : false,

        disabled_button_upload_login     : true,
        disabled_button_upload_dashboard : true,
        disabled_button_upload_report    : true,
        disabled_file_upload_login       : false,
        disabled_file_upload_dashboard   : false,
        disabled_file_upload_report      : false,

        thumb_img_login     : null,
        thumb_img_dashboard : null,
        thumb_img_report    : null,

        progress : 0,
    }

    this.readImage = this.readImage.bind(this)
    this.handleChangeBrand = this.handleChangeBrand.bind(this)

    this.uploadLogo = this.uploadLogo.bind(this)

    this.removeLogo = this.removeLogo.bind(this)
    this.removeLogoSuccess = this.removeLogoSuccess.bind(this)
    this.removeLogoFailed = this.removeLogoFailed.bind(this)

    this.handleData = this.handleData.bind(this);

    this.UpdateSuccess = this.UpdateSuccess.bind(this);
    this.UpdateFailed = this.UpdateFailed.bind(this);

    this.ReadMasterSuccess = this.ReadMasterSuccess.bind(this)

    this.form_data = new FormData()
    this.payload = []
    this.current_upload = null
  }

  handleSingleCurrencyChange(event) {
    const {DefaultCurrency} = this.state
    /**
    |----------------------- Note ---------------------------
    | select query is array empty if data null
    |--------------------------------------------------
    */
    if(Array.isArray(DefaultCurrency)) {
      toast.warning("INFO: to active single currency, please select your default currency.")
    } else {
      this.setState({
        toggled: event.target.checked,
        SingleCurrency: event.target.checked ? 'True' : 'False',
      })
    }
  }

  handleDefaultCurrencyChange(val) {
    let new_state = {
      DefaultCurrency: val
    }
    /**
    |----------------------- Note ---------------------------
    | select query is array empty if data null
    |--------------------------------------------------
    */
    if(Array.isArray(val)) {
      new_state = {
        toggled: false,
        SingleCurrency: 'False',
        DefaultCurrency: val,
      }
    }
    this.setState(new_state)
  }

  handleCoverageCityChange(event) {
    this.setState({
      CoverageCity: event.target.checked,
    })
  }

  loadDataMaster(action) {
    Presenter.ReadAsMaster(
        RequestProperties.ReadMasterProps(action, this, this.ReadMasterSuccess, this.ReadMasterFailed)
    )
  }

  convertNulltoArray(res) {
    /**
    |-------------------- Note ------------------------------
    | this function is used for convert response null from API to array empty [], WHY?
    | because component SelectQuery.js must return [] if data autocomplete has clear or remove manualy by user
    | please notice this note....
    |--------------------------------------------------
    */
    let result = res
    if(res === null || res === undefined) {
      result = []
    }
    return result
  }

  ReadMasterSuccess(params, response) {
    let new_state = {
      SelectedSetting   : response.data[0],
      GlobalMaxDay      : response.data[0].GlobalMaxDay,
      UrgencyDay        : response.data[0].Urgency,
      StorageType       : response.data[0].StorageType,
      InactiveStatus    : response.data[0].InactiveStatus,
      MaintenanceType   : response.data[0].MaintenanceType,
      MaintenanceStatus : response.data[0].MaintenanceStatus,
      StorageStatus     : response.data[0].StorageStatus,
      BusyStatus        : response.data[0].BusyStatus,
      BrokenStatus      : response.data[0].BrokenStatus,
      LostStatus        : response.data[0].LostStatus,
      AdminRole         : response.data[0].AdminRole,
      StorageRole       : response.data[0].StorageRole,
      DefaultCurrency   : this.convertNulltoArray(response.data[0].DefaultCurrency),
      // DefaultCurrency   : response.data[0].DefaultCurrency,
      SingleCurrency    : 'False',
      CoverageCity      : response.data[0].CoverageCity,
      toggled           : false,
      CustomBranding    : response.data[0].CustomBranding,
    }

    if(Array.isArray(new_state.DefaultCurrency)) {
      // force disable flag single currency where no one selected in DefaultCurrency
      new_state.toggled = false
      new_state.SingleCurrency = 'False'
    } else {
      new_state.toggled = response.data[0].SingleCurrency
      new_state.SingleCurrency = response.data[0].SingleCurrency ? 'True' : 'False'
    }
    
    this.setState(new_state)
  }

  ReadMasterFailed(response) {
  }

  update() {
    let checkComa = this.state.GlobalMaxDay % 1 || this.state.UrgencyDay % 1;
    let globalMaxDayString = this.state.GlobalMaxDay.toString();
    let urgencyDayString = this.state.UrgencyDay.toString();

    if(!globalMaxDayString){
        toast.warning("Max Day Empty")
        return false;
    } else if(!urgencyDayString){
        toast.warning("Urgency Day Empty")
        return false;
    } else if(checkComa !== 0 ) {
        toast.warning("Must integer number")
        return false;
    } else if(globalMaxDayString <= 0){
        toast.warning("must be greater than 0")
    } else {
        Presenter.Update(
            RequestProperties.Update(this, this.UpdateSuccess, this.UpdateFailed)
        )
    }
  }

  UpdateSuccess(params, response) {
    try {
      this.props.RunRedux(UpdateTenantCoverage(response.data.CoverageCity))
    } catch (e) {

    }
    toast.success("Update Success")
  }

  UpdateFailed(response) {
    toast.error(response)
  }

  getUrlRequest(mode, type) {
    if(mode === "delete") {
      if(type === "login") {
        this.current_upload = "LoginLogo"
        return "delete-login-logo"

      } else if(type === "dashboard") {
        this.current_upload = "DashboardLogo"
        return "delete-dashboard-logo"

      } else {
        this.current_upload = "ReportLogo"
        return "delete-report-logo"
      }
    }
  }

  removeLogo(type) {
    Request(
      "delete",
      this.getUrlRequest("delete", type),
      {"Authorization" : "Bearer " + this.props.UserReducer.token},
      {},
      [],
      this.removeLogoSuccess(),
      this.removeLogoFailed()
    )
  }

  removeLogoSuccess(response) {
    alert('Delete success')
    this.updateImageRedux(null)
  }

  removeLogoFailed(error) {

  }

  componentDidMount() {
    this.loadDataMaster("TENANT_SETTING");
    // ****** load more master on did mount can make an error.
    // ****** sometimes data success load but blank in field 
    // this.loadDataMaster("CURRENCY");
  }

  componentWillUnmount() {
    windowStop()
  }

  resetFormData() {
    if(this.current_upload === "LoginLogo") {
      this.form_data.delete("LoginLogo")
      this.fileLogin.value = null

    } else if(this.current_upload === "DashboardLogo") {
      this.form_data.delete("DashboardLogo")
      this.fileDashboard.value = null

    } else if(this.current_upload === "ReportLogo"){
      this.form_data.delete("ReportLogo")
      this.fileReport.value = null
    }
  }

  disableButton(value_btn, value_file) {
    if(this.current_upload === "LoginLogo") {
      this.setState({
        disabled_button_upload_login: value_btn,
        disabled_file_upload_login: value_file,
      })

    } else if(this.current_upload === "DashboardLogo") {
      this.setState({
        disabled_button_upload_dashboard: value_btn,
        disabled_file_upload_dashboard: value_file,
      })

    } else if(this.current_upload === "ReportLogo"){
      this.setState({
        disabled_button_upload_report: value_btn,
        disabled_file_upload_report: value_file,
      })
    }
  }

  /** SOCKET */
  handleData(msg) {
    let socket_response =JSON.parse(msg)
    if(socket_response.type === "settings") {
      if(socket_response.action === "update") {
        this.updateImageRedux(socket_response.data.url, socket_response.key)

      } else if (socket_response.action === "delete") {
        this.updateImageRedux(null, socket_response.key)
      }
    }

  }

  handleWSOpen(){
    console.info("Socket Tenant Settings Connected");
  };

  handleWSClose(){
    console.info("Socket Tenant Settings Disconnected!");
  };
  /** END SOCKET */


  updateImageRedux(url, action_socket=null) {
    let action

    if(action_socket === null) {
      action = this.current_upload
    } else {
      action = action_socket
    }
    if(action === "LoginLogo") {
      this.props.RunRedux(UpdateTenantLogoLoginSession(url))
      this.setState({thumb_img_login:null})

    } else if(action === "DashboardLogo") {
      this.props.RunRedux(UpdateTenantLogoDashboardSession(url))
      this.setState({thumb_img_dashboard:null})

    } else {
      this.props.RunRedux(UpdateTenantLogoReportSession(url))
      this.setState({thumb_img_report:null})
    }
  }

  cancelUploadLogo(type) {
    if(type === "login") {
      this.fileLogin.value = null
      this.setState({
        thumb_img_login: null,
        disabled_button_upload_login:true
      })

    } else if(type === "dashboard") {
      this.fileDashboard.value = null
      this.setState({
        thumb_img_dashboard: null,
        disabled_button_upload_dashboard:true
      })

    } else {
      this.fileReport.value = null
      this.setState({
        thumb_img_report: null,
        disabled_button_upload_report:true
      })
    }
  }

  uploadLogo(type) {
    let url

    if(type === "login") {
      url = "update-login-logo"
      this.current_upload = "LoginLogo"

    } else if(type === "dashboard") {
      url = "update-dashboard-logo"
      this.current_upload = "DashboardLogo"

    } else {
      url = "update-report-logo"
      this.current_upload = "ReportLogo"
    }

    let config = {
      onUploadProgress: function(progressEvent) {
        let percent = Math.round( (progressEvent.loaded * 100) / progressEvent.total )
        this.setState({
          progress: percent,
        })
        this.disableButton(true, true)
      }.bind(this)
    }

    axios.defaults.headers.common["Authorization"] = "Bearer " + this.props.UserReducer.token
    axios.defaults.headers.common["Content-Type"] = "multipart/form-data"

    axios.put(server.ATM_CLOUD.API + urls[url], this.payload, config)
      .then(function (res) {
        if(this.state.progress >= 100) {
          alert("upload success")
          if(res !== undefined) {
            if(res.hasOwnProperty("data")) {
              if(res.data !== undefined) {
                if(res.data.hasOwnProperty("url")) {
                  this.updateImageRedux(res.data.url)
                }
              }
            }
          }
        }

        this.resetFormData()
        this.setState({
          progress: 0,
        })
        this.disableButton(true, false)

      }.bind(this))

      .catch(function (err) {
        if(err !== undefined ) {
          if(err.hasOwnProperty("response")) {
            if(err.response !== undefined) {
              if(err.response.hasOwnProperty("data")) {
                if(typeof err.response.data !== "object" && err.response.data !== null ) {
                  alert("Error: Server must return object!");
                } else {
                  for(let i in err.response.data) {
                    alert("Upload failed, error : " + err.response.data[i][0])
                  }
                }
              }
            }
          }
        }

        this.setState({
          progress: 0,
        })
        this.disableButton(false, false)

      }.bind(this))
  }

  readImage(_file) {
    var fr = new FileReader(); /*before without () */
    let file = _file.files[0]

    if(file && file.type.match('image.*')) {

      fr.onload = function () {
        var img = new Image(); /*before without () */

        img.onload = function () {
          var w = img.width;
          var h = img.height;

          if(this.current_upload === "LoginLogo") {
            if(w < WIDTH_LOGIN || h < HEIGHT_LOGIN) {
              alert('image width must be '+ WIDTH_LOGIN +'px & height must be '+HEIGHT_LOGIN+'px')
              this.resetFormData()
              this.disableButton(true, false)
              return
            } else {
              this.setState({
                thumb_img_login: URL.createObjectURL(file)
              })
            }

          } else if(this.current_upload === "DashboardLogo") {
            if(w < WIDTH_DASHBOARD || h < HEIGHT_DASHBOARD) {
              alert('image width must be '+ WIDTH_DASHBOARD +'px & height must be '+ HEIGHT_DASHBOARD +'px')
              this.resetFormData()
              this.disableButton(true, false)
              return
            } else{
              this.setState({
                thumb_img_dashboard: URL.createObjectURL(file)
              })
            }

          } else {
            if(w < WIDTH_REPORT || h < HEIGHT_REPORT) {
              alert('image width must be '+ WIDTH_REPORT +'px & height must be '+ HEIGHT_REPORT +'px')
              this.resetFormData()
              this.disableButton(true, false)
              return
            } else {
              this.setState({
                thumb_img_report: URL.createObjectURL(file)
              })
            }
          }

        }.bind(this);

        img.src = fr.result;

      }.bind(this);

      fr.readAsDataURL(file);

    } else if(file && !file.type.match('image.*')) {
      alert("Invalid file type, only support image")
      this.resetFormData();
      this.disableButton(true, false)

    } else {
      this.setState({
        disabled_button_upload_login     :true,
        disabled_button_upload_dashboard :true,
        disabled_button_upload_report    :true,
        thumb_img_login                  :null,
        thumb_img_dashboard              :null,
        thumb_img_report                 :null,
      })
    }
  }

  handleChangeBrand(e) {
    let file = e.target.files
    let name = e.target.name

    if(name === "login-logo") {
      this.form_data.append("LoginLogo", file[0])
      this.current_upload = "LoginLogo"
      this.setState({
        disabled_button_upload_login: false,
      })

    } else if(name === "dashboard-logo") {
      this.form_data.append("DashboardLogo", file[0])
      this.current_upload = "DashboardLogo"
      this.setState({disabled_button_upload_dashboard: false})

    } else if(name === "report-logo"){
      this.form_data.append("ReportLogo", file[0])
      this.current_upload = "ReportLogo"
      this.setState({disabled_button_upload_report: false})
    }

    this.payload = this.form_data
    this.readImage(e.target)
  }

  renderProgressBar() {
    if(this.state.progress >= 1) {
      return (
        <div className="progress">
          <div
            className="progress-bar"
            role="progressbar"
            style={{"width":this.state.progress + "%"}}
            aria-valuenow={this.state.progress}
            aria-valuemin="0"
            aria-valuemax="100">
            {this.state.progress + "%"}
          </div>
        </div>
      )
    }
  }

  renderCustomBrand(){
    if(this.state.CustomBranding && this.props.UserReducer.props.isAdmin) {
      return(
        <div className="card">
          <div className="card-header">
            <i className="fa fa-align-justify"></i>Custom Branding
          </div>
          <div className="card-block">
            <div className="row">
              <div className="col-md-12">
                <div className="list-separator m-top-15" style={{ border : 'none'}}>
                  <div className="item-inner">
                    Custom Branding
                    <PopoverHelper
                      id="img_logo"
                      content={lang.tenant_setting.custom_branding}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-12 mb-3">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Login Logo</label>
                      <div className="input-group suffix">
                        <input
                          type="file"
                          className="form-control"
                          name="login-logo"
                          accept="image/png, image/jpeg"
                          ref={ref=> this.fileLogin = ref}
                          onChange={this.handleChangeBrand}
                          disabled={this.state.disabled_file_upload_login}
                        />
                        <span className="input-group-addon white-background no-padding">
                          <button
                            className="btn btn-link apple-yellow"
                            onClick={()=>this.cancelUploadLogo("login")}
                            disabled={this.state.disabled_button_upload_login}
                          >Cancel</button>
                        </span>
                        <span className="input-group-addon white-background no-padding">
                          <button
                            className="btn btn-link"
                            onClick={()=>this.uploadLogo("login")}
                            disabled={this.state.disabled_button_upload_login}
                          >Upload</button>
                        </span>
                      </div>
                      {this.current_upload === "LoginLogo" && this.renderProgressBar()}
                      <div className="good-tips">
                        Best Tips:
                        <ul>
                          <li>Resolution : width {WIDTH_LOGIN}px - height {HEIGHT_LOGIN}px <small className="apple-red">(Mandatory)</small></li>
                          <li>Background : Transparent / White</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3 offset-md-3">
                    <div className="form-group">
                      <div className="tenant-img-thumb __square bg-transparent-pattern">
                        {this.state.thumb_img_login === null ?
                          <img
                            src={getLogoBranding("login", this.props.TenantReducer.login)}
                            alt="Login Logo"
                          />
                          :
                          <img
                            src={getLogoBranding("login", this.state.thumb_img_login)}
                            alt="Login Logo"
                          />
                        }
                      </div>
                      {this.props.TenantReducer.login !== null &&
                        <a role="button" onClick={()=>this.removeLogo('login')} className="apple-red">Delete & use default logo</a>
                      }
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Dashboard Logo</label>
                      <div className="input-group suffix">
                        <input
                          type="file"
                          className="form-control"
                          name="dashboard-logo"
                          accept="image/png, image/jpeg"
                          ref={ref=> this.fileDashboard = ref}
                          onChange={this.handleChangeBrand}
                          disabled={this.state.disabled_file_upload_dashboard}
                        />
                        <span className="input-group-addon white-background no-padding">
                          <button
                            className="btn btn-link apple-yellow"
                            onClick={()=>this.cancelUploadLogo("dashboard")}
                            disabled={this.state.disabled_button_upload_dashboard}
                          >Cancel</button>
                        </span>
                        <span className="input-group-addon white-background no-padding">
                          <button
                            className="btn btn-link"
                            onClick={()=>this.uploadLogo("dashboard")}
                            disabled={this.state.disabled_button_upload_dashboard}
                          >Upload</button>
                        </span>
                      </div>
                      {this.current_upload === "DashboardLogo" && this.renderProgressBar()}
                      <div className="good-tips">
                        Best Tips:
                        <ul>
                          <li>Resolution : width {WIDTH_DASHBOARD}px - height {HEIGHT_DASHBOARD}px <small className="apple-red">(Mandatory)</small></li>
                          <li>Background : Transparant <small className="apple-red">(Mandatory)</small></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3 offset-md-3">
                    <div className="form-group">
                      <div className="tenant-img-thumb __rectangle bg-transparent-pattern">
                        {this.state.thumb_img_dashboard == null ?
                          <img
                            src={getLogoBranding("dashboard", this.props.TenantReducer.dashboard)}
                            alt="Dashboard Logo"
                          />
                        :
                          <img
                            src={getLogoBranding("dashboard", this.state.thumb_img_dashboard)}
                            alt="Dashboard Logo"
                          />
                        }
                      </div>
                      {this.props.TenantReducer.dashboard !== null &&
                        <a role="button" onClick={()=>this.removeLogo('dashboard')} className="apple-red">Delete & use default logo</a>
                      }
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Report Logo</label>
                      <div className="input-group suffix">
                        <input
                          type="file"
                          className="form-control"
                          name="report-logo"
                          accept="image/png, image/jpeg"
                          ref={ref=> this.fileReport = ref}
                          onChange={this.handleChangeBrand}
                          disabled={this.state.disabled_file_upload_report}
                        />
                        <span className="input-group-addon white-background no-padding">
                          <button
                            className="btn btn-link apple-yellow"
                            onClick={()=>this.cancelUploadLogo("report")}
                            disabled={this.state.disabled_button_upload_report}
                          >Cancel</button>
                        </span>
                        <span className="input-group-addon white-background no-padding">
                          <button
                            className="btn btn-link"
                            onClick={()=>this.uploadLogo("report")}
                            disabled={this.state.disabled_button_upload_report}
                          >Upload</button>
                        </span>
                      </div>
                      {this.current_upload === "ReportLogo" && this.renderProgressBar()}
                      <div className="good-tips">
                        Best Tips:
                        <ul>
                          <li>Resolution : width {WIDTH_REPORT}px - height {HEIGHT_REPORT}px <small className="apple-red">(Mandatory)</small></li>
                          <li>Background : Transparant</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3 offset-md-3">
                    <div className="form-group">
                      <div className="tenant-img-thumb __rectangle bg-transparent-pattern">
                        {this.state.thumb_img_report === null ?
                          <img
                            src={getLogoBranding("report", this.props.TenantReducer.report)}
                            alt="Report Logo"
                          />
                          :
                          <img
                            src={getLogoBranding("report", this.state.thumb_img_report)}
                            alt="Report Logo"
                          />
                        }
                      </div>
                      {this.props.TenantReducer.report !== null &&
                        <a role="button" onClick={()=>this.removeLogo('report')} className="apple-red">Delete & use default logo</a>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    } else {
      return null
    }
  }

  renderTenantSetting() {
    if(UserHelper.HasPermission(PermissionProperties.MASTER.TENANT_SETTING.READ, this.props.UserReducer)) {
        return (
          <div className="card-block">
              <div className="row">
                <div className="col-md-12">
                  <div className="list-separator m-top-15" style={{ border : 'none'}}>
                    <div className="item-inner">
                      DEFAULT VALUE
                      <PopoverHelper
                        id="default_mapping"
                        content={lang.tenant_setting.default_value}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Tenant Name</label>
                    <input type="text" className="form-control" value={this.state.SelectedSetting.Tenant || ''} readOnly/>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-group">
                    <label>Default Currency</label>
                      <SelectQuery
                        name="Site"
                        placeholder="Storage Type"
                        value={this.state.DefaultCurrency}
                        urlKey="read-currency-autocomplete"
                        valKey="pk"
                        valLabel="Name"
                        extra={'all=true'}
                        initOption={this.state.DefaultCurrency}
                        onChange={(val) => this.handleDefaultCurrencyChange(val)}
                        UserReducer={this.props.UserReducer}
                      />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <div><label>Single Currency</label></div>
                    <label className="switch switch-lg switch-text switch-primary mb0">
                      <input
                        onChange={(event)=>this.handleSingleCurrencyChange(event)}
                        name='singleCurency'
                        type="checkbox"
                        className="switch-input"
                        // ******** WHY NEED CHECKED USE !!. because this.state.toggled not always boolean.
                        // ******** and it make uncontroled component, for first time value for toggled is undifined
                        checked={!!this.state.toggled}
                      />
                      <span className="switch-label" data-on="On" data-off="Off"></span>
                      <span className="switch-handle"></span>
                    </label>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    Max Day
                    <PopoverHelper
                      id="max_day"
                      content={lang.tenant_setting.max_day}
                    />
                    <input
                      type="number"
                      name="GlobalMaxDay"
                      className="form-control"
                      placeholder="Max day"
                      value = {this.state.GlobalMaxDay || 0}
                      onChange={(val)=> this.setState({GlobalMaxDay: val.target.value})}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    Urgency Day
                    <PopoverHelper
                      id="urgency_day"
                      content={lang.tenant_setting.urgency_day}
                    />
                    <input
                      type="number"
                      name="UrgencyDay"
                      className="form-control"
                      placeholder="Urgency day"
                      value = {this.state.UrgencyDay || 0}
                      onChange={(val)=> this.setState({UrgencyDay: val.target.value})}
                    />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <div>
                    Coverage City
                    <PopoverHelper
                      id="coverage_city"
                      placement="bottom"
                      content={lang.tenant_setting.coverage_city}
                    /></div>
                    <label className="switch switch-lg switch-text switch-primary mb0">
                      <input
                        onChange={(event)=>this.handleCoverageCityChange(event)}
                        name='singleCurency'
                        type="checkbox"
                        className="switch-input"
                        // ******** WHY NEED CHECKED USE !!. because this.state.CoverageCity not always boolean.
                        // ******** and it make uncontroled component, for first time value for CoverageCity is undifined
                        checked={!!this.state.CoverageCity} 
                      />
                      <span className="switch-label" data-on="On" data-off="Off"></span>
                      <span className="switch-handle"></span>
                    </label>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="list-separator m-top-15" style={{ border : 'none'}}>
                    <div className="item-inner">
                      Site Type Mapping
                      <PopoverHelper
                        id="site_type_mapping"
                        content={lang.tenant_setting.site_mapping}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Storage Site Type</label>
                    <SelectQuery
                      name="Site"
                      placeholder="Storage Type"
                      value={this.state.StorageType}
                      urlKey="read-site-type-autocomplete"
                      valKey="Alias"
                      valLabel="Name"
                      initOption={this.state.StorageType || null}
                      onChange={(val) => this.setState({StorageType: val})}
                      UserReducer={this.props.UserReducer}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Maintenance Site Type</label>
                    <SelectQuery
                      placeholder="Maintenance Type"
                      value={this.state.MaintenanceType}
                      urlKey="read-site-type-autocomplete"
                      valKey="Alias"
                      valLabel="Name"
                      initOption={this.state.MaintenanceType || null}
                      onChange={(val) => this.setState({MaintenanceType: val})}
                      UserReducer={this.props.UserReducer}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="list-separator m-top-15" style={{ border : 'none'}}>
                    <div className="item-inner">
                      Site Status Mapping
                      <PopoverHelper
                        id="site_status_mapping"
                        content={lang.tenant_setting.status_mapping}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Inactive Site Status</label>
                    <SelectQuery
                      name="Site"
                      placeholder="Storage Type"
                      value={this.state.InactiveStatus}
                      urlKey="read-site-status-autocomplete"
                      valKey="Alias"
                      valLabel="Name"
                      initOption={this.state.InactiveStatus || null}
                      onChange={(val) => this.setState({InactiveStatus: val})}
                      UserReducer={this.props.UserReducer}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="list-separator m-top-15" style={{ border : 'none'}}>
                    <div className="item-inner">
                      Role Mapping
                      <PopoverHelper
                        id="role_mapping"
                        content={lang.tenant_setting.role_mapping}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Admin Role</label>
                    <SelectQuery
                      placeholder="Admin Role"
                      value={this.state.AdminRole || null}
                      urlKey="read-role-autocomplete"
                      valKey="Alias"
                      valLabel="Name"
                      initOption={this.state.AdminRole || null}
                      onChange={(val) => this.setState({AdminRole: val})}
                      UserReducer={this.props.UserReducer}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Storage Role</label>
                    <SelectQuery
                      placeholder="Storage Role"
                      value={this.state.StorageRole}
                      urlKey="read-role-autocomplete"
                      valKey="Alias"
                      valLabel="Name"
                      initOption={this.state.StorageRole || null}
                      onChange={(val) => this.setState({StorageRole: val})}
                      UserReducer={this.props.UserReducer}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="list-separator m-top-15" style={{ border : 'none'}}>
                    <div className="item-inner">
                      Asset Status Mapping
                      <PopoverHelper
                        id="asset_status_mapping"
                        content={lang.tenant_setting.asset_mapping}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label>Storage Status</label>
                    <SelectQuery
                      placeholder="Storage Status"
                      value={this.state.StorageStatus}
                      urlKey="read-asset-status-autocomplete"
                      valKey="Alias"
                      valLabel="Name"
                      initOption={this.state.StorageStatus || null}
                      onChange={(val) => this.setState({StorageStatus: val})}
                      UserReducer={this.props.UserReducer}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                      <label>Maintenance Status</label>
                      <SelectQuery
                        placeholder="Maintenance Status"
                        value={this.state.MaintenanceStatus}
                        urlKey="read-asset-status-autocomplete"
                        valKey="Alias"
                        valLabel="Name"
                        initOption={this.state.MaintenanceStatus || null}
                        onChange={(val) => this.setState({MaintenanceStatus: val})}
                        UserReducer={this.props.UserReducer}
                      />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label>Busy Status</label>
                    <SelectQuery
                      placeholder="Busy Status"
                      value={this.state.BusyStatus}
                      urlKey="read-asset-status-autocomplete"
                      valKey="Alias"
                      valLabel="Name"
                      initOption={this.state.BusyStatus || null}
                      onChange={(val) => this.setState({BusyStatus: val})}
                      UserReducer={this.props.UserReducer}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                    <div className="form-group">
                      <label>Broken Status</label>
                      <SelectQuery
                        placeholder="Broken Status"
                        value={this.state.BrokenStatus}
                        urlKey="read-asset-status-autocomplete"
                        valKey="Alias"
                        valLabel="Name"
                        initOption={this.state.BrokenStatus || null}
                        onChange={(val) => this.setState({BrokenStatus: val})}
                        UserReducer={this.props.UserReducer}
                      />
                    </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label>Lost Status</label>
                    <SelectQuery
                      placeholder="Lost Status"
                      value={this.state.LostStatus}
                      urlKey="read-asset-status-autocomplete"
                      valKey="Alias"
                      valLabel="Name"
                      initOption={this.state.LostStatus || null}
                      onChange={(val) => this.setState({LostStatus: val})}
                      UserReducer={this.props.UserReducer}
                    />
                  </div>
                </div>
              </div>
              <hr/>
              <button type="button" onClick={()=>this.update()} className="btn btn-primary pull-right">Update</button>
          </div>
        )
    } else {
      return(
        <div className="card-block">
          <div className="h-60vh-c flex-row align-items-center">
            <h3 className="text-center color-visible">You dont have permision</h3>
          </div>
        </div>
      )
    }
  }

  renderLoading() {
    return(
      <div className="align-center" style={{'height': '100vh'}}>
        <h3 style={{'color':'#939494'}}>Load Tenant Setting...</h3>
      </div>
    )
  }

  render() {
    if(!this.state.SelectedSetting) {
      return this.renderLoading()
    } else {
      return (
        <div className="container-fluid">
          <div className="animated fadeIn">
              <div className="card">
                  <div className="card-header">
                      <i className="fa fa-align-justify"></i>Tenant Setting
                  </div>
                  {this.renderTenantSetting()}
              </div>
              {this.renderCustomBrand()}
          </div>
          <Websocket
            url={ServerProperties.ATM_CLOUD.WS + 'chat/' + this.props.UserReducer.token}
            onMessage={this.handleData}
            onOpen={this.handleWSOpen}
            onClose={this.handleWSClose}
            reconnect={true}
            debug={false}
            ref='socket'
          />
        </div>
      );
    }
    
  }
}
const mapStateToProps = (state) => {
  return {
    UserReducer: state.UserReducer,
    TenantReducer: state.TenantReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    RunRedux: (data) => {
      dispatch(data);
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TenantSetting)



// WEBPACK FOOTER //
// ./src/App/views/templates/dashboard/master/tenant_setting.js